import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import GlobalStyles from "./styles/GlobalStyles";
import { darkTheme } from "./styles/theme";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import About from "./pages/About";
import Resume from "./pages/Resume";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import styled from "styled-components";

export default function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <Router>
        <GlobalStyles />
        <AppLayout>
          <Sidebar />
          <Main>
            <Navbar />
            <Content>
              <Routes>
                <Route path="/" element={<About />} />
                <Route path="/resume" element={<Resume />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </Content>
          </Main>
        </AppLayout>
      </Router>
    </ThemeProvider>
  );
}

const AppLayout = styled.div`
  display: flex;
  min-height: 100vh;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Main = styled.div`
  flex: 1;
  padding-left: 260px;
  transition: padding-left 0.3s ease;

  @media (max-width: 768px) {
    padding-left: 0;
  }
`;

const Content = styled.div`
  padding: 40px 80px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;



